import React from "react";
import { formatPrice } from "../../../utils/formatPrice";

const BestStores = ({ data, currency_code, currency_factor }) => {
  console.log("data", data);
  const places = ["الأول", "الثاني", "الثالث"];
  return (
    <section className="card  rounded-4">
      <div className="card-body">
        <h6 className="mb-4">أفضل المتاجر أداءً</h6>

        <ul>
          {data.map((store ,index) => (
            <li key={store.id}>
              <div className="best-store-card ">
                <div className="d-flex gap-2 align-items-center">
                  <div> 🏅</div>
                  <div>
                    <h4>{store.name}</h4>
                    <p>
                      {currency_code} {formatPrice(currency_factor, store.revenue)}  sales in 
                    </p>
                  </div>
                </div>
                <div className="fs-5">الطلبات: {store.order_count}</div>
                <div className="place-badge">المركز   {places[index] || index + 1}</div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default BestStores;
